export default function BunchhLogo({ height = 32, className = '' }) {
  return (
    <img
      src="/logo.svg"
      alt="Bunchh"
      style={{ height, width: 'auto' }}
      className={className}
      data-testid="bunchh-logo"
    />
  );
}
